import { render, staticRenderFns } from "./ChoiceQuestion.vue?vue&type=template&id=28a2569e&scoped=true&lang=html&"
import script from "./ChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./ChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceQuestion.vue?vue&type=style&index=0&id=28a2569e&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2569e",
  null
  
)

export default component.exports